import { render } from "./Legacy.vue?vue&type=template&id=4c905634"
import script from "./Legacy.vue?vue&type=script&lang=js"
export * from "./Legacy.vue?vue&type=script&lang=js"

import "./Legacy.vue?vue&type=style&index=0&id=4c905634&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__